import { Injectable } from '@angular/core';
import { ApolloServiceConfig } from '@src/app/configs/apollo.service.config';
import { HttpClient } from '@angular/common/http';
import { ConfigurationOrder, Id } from '@ess/jg-rule-executor';
import { firstValueFrom } from 'rxjs';
import { JSON } from 'ta-json';

@Injectable({
  providedIn: 'root',
})
export class AssetService {
  public readonly UPLOAD_URL_CONFIG_ORDER: string = `${this._config.backendUrl}/graphql/uploadConfigurationOrderImage`;

  constructor(
    private _config: ApolloServiceConfig,
    private _httpClient: HttpClient,
  ) {
  }

  public async uploadConfigurationOrderImage$(file: File, orderId: Id<ConfigurationOrder>): Promise<string> {
    if (!file || !(file instanceof File)) {
      throw new Error('Invalid file provided for upload');
    }

    const formData = new FormData();
    formData.append('asset', file);
    formData.append('configurationOrder', orderId.toString());

    const result = await firstValueFrom(this._httpClient.post(
      this.UPLOAD_URL_CONFIG_ORDER,
      formData,
      { observe: 'response', withCredentials: true }
    ));

    if (!result.ok) {
      throw new Error('Invalid asset upload response');
    }

    return JSON.deserialize<string>(result.body);
  }
}
